import { Outlet } from "react-router-dom";

import { usePermissoes } from "@/modules/permissoes";
import { Navigator } from "@/shared/components";

import { PageWrapper } from "./components/page-wrapper";
import { useMenuItems, useSecondaryMenuItems } from "./layout.constants";
import styles from "./layout.module.scss";

export function AppLayout() {
  // Busca as permissões já ao entrar: o cache da sessão fica pronto antes de qualquer modal abrir,
  // e botões que dependem de privilégio (ex.: Gerar ficha, Adicionar Arquivo) não esperam a requisição.
  usePermissoes();
  const menuItems = useMenuItems();
  const secondaryMenuItems = useSecondaryMenuItems();

  return (
    <div className={styles.layout} data-testid="app-layout">
      <Navigator items={menuItems} secondaryItems={secondaryMenuItems} />
      <div className={styles.main}>
        <PageWrapper>
          <Outlet />
        </PageWrapper>
      </div>
    </div>
  );
}
